(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tribu-home-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('.tribu-header #sidebar-menu a[href^="#"]');
  if (link) { const drawer = link.closest('header-sidebar'); if (typeof drawer.hide === 'function') drawer.hide(); }
});

  } catch(e) { console.error(e); }
})();
})();
